import { render, staticRenderFns } from "./WxModal.vue?vue&type=template&id=3423eb59&scoped=true"
import script from "./WxModal.vue?vue&type=script&lang=js"
export * from "./WxModal.vue?vue&type=script&lang=js"
import style0 from "./WxModal.vue?vue&type=style&index=0&id=3423eb59&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3423eb59",
  null
  
)

export default component.exports